/*
  DIVINE LUXE: product gallery.
  1. Clicking a product image opens a full-screen viewer (one image at a time, arrows, counter,
     thumbnails, swipe, Esc / arrow keys) instead of the theme's stacked zoom modal.
     Images only; videos and 3D models keep the theme's own behaviour.
  2. Mobile: the arrows and "1 / 5" counter on the main image (the theme switches them off when the
     thumbnail strip is on, so they are driven here).
  3. Images inside the product description only load when the Description accordion is opened,
     at a capped width (templates/product.json renders them with data-dl-src instead of src).
  Styles: .dl-lb and the gallery rules in assets/dl-product.css.
*/
(function () {
  if (window.dlLightbox) return;
  window.dlLightbox = true;

  /* ---------- 1. Full-screen preview ---------- */
  var lb, stage, img, counter, thumbs, prevBtn, nextBtn, closeBtn;
  var images = [];
  var index = 0;
  var opener = null;
  var touchX = null;

  function largestSrc(el) {
    var set = el.getAttribute('srcset');
    if (!set) return el.currentSrc || el.src;
    var best = null, bestW = 0;
    set.split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      var w = parseInt(bits[1], 10) || 0;
      if (w > bestW) { bestW = w; best = bits[0]; }
    });
    return best || el.currentSrc || el.src;
  }

  function collect(gallery) {
    var list = [];
    gallery.querySelectorAll('.product__media-list > .product__media-item').forEach(function (item) {
      var pic = item.querySelector('.product__media img');
      if (!pic || item.querySelector('video, model-viewer, iframe, deferred-media')) return;
      list.push({ id: item.getAttribute('data-media-id'), src: largestSrc(pic), thumb: pic.currentSrc || pic.src, alt: pic.alt || '' });
    });
    return list;
  }

  function build() {
    lb = document.createElement('div');
    lb.className = 'dl-lb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Product images');
    lb.hidden = true;
    lb.innerHTML =
      '<div class="dl-lb__top"><span class="dl-lb__count" aria-live="polite"></span>' +
      '<button type="button" class="dl-lb__btn dl-lb__close" aria-label="Close"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="dl-lb__stage">' +
      '<button type="button" class="dl-lb__btn dl-lb__nav dl-lb__prev" aria-label="Previous image"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<img class="dl-lb__img" alt="">' +
      '<button type="button" class="dl-lb__btn dl-lb__nav dl-lb__next" aria-label="Next image"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '</div>' +
      '<div class="dl-lb__thumbs" role="list"></div>';
    document.body.appendChild(lb);
    stage = lb.querySelector('.dl-lb__stage');
    img = lb.querySelector('.dl-lb__img');
    counter = lb.querySelector('.dl-lb__count');
    thumbs = lb.querySelector('.dl-lb__thumbs');
    prevBtn = lb.querySelector('.dl-lb__prev');
    nextBtn = lb.querySelector('.dl-lb__next');
    closeBtn = lb.querySelector('.dl-lb__close');

    prevBtn.addEventListener('click', function () { show(index - 1); });
    nextBtn.addEventListener('click', function () { show(index + 1); });
    closeBtn.addEventListener('click', close);
    stage.addEventListener('click', function (e) { if (e.target === stage) close(); });
    lb.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(index - 1);
      else if (e.key === 'ArrowRight') show(index + 1);
      else if (e.key === 'Tab') trapFocus(e);
    });
    stage.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
    });
  }

  function trapFocus(e) {
    var focusable = Array.prototype.filter.call(lb.querySelectorAll('button'), function (b) { return !b.hidden && !b.closest('[hidden]'); });
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function show(i) {
    if (!images.length) return;
    index = (i + images.length) % images.length;
    var item = images[index];
    img.classList.remove('is-loaded');
    img.onload = function () { img.classList.add('is-loaded'); };
    img.src = item.src;
    img.alt = item.alt;
    if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
    counter.textContent = (index + 1) + ' / ' + images.length;
    thumbs.querySelectorAll('button').forEach(function (b, n) {
      b.setAttribute('aria-current', n === index ? 'true' : 'false');
      if (n === index) b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
    var single = images.length < 2;
    prevBtn.hidden = single;
    nextBtn.hidden = single;
    thumbs.hidden = single;
  }

  function open(gallery, mediaId, trigger) {
    images = collect(gallery);
    if (!images.length) return false;
    if (!lb) build();
    thumbs.innerHTML = '';
    images.forEach(function (item, n) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'dl-lb__thumb';
      b.setAttribute('role', 'listitem');
      b.setAttribute('aria-label', 'Image ' + (n + 1));
      b.innerHTML = '<img src="' + item.thumb + '" alt="" loading="lazy">';
      b.addEventListener('click', function () { show(n); });
      thumbs.appendChild(b);
    });
    var start = 0;
    images.forEach(function (item, n) { if (item.id === mediaId) start = n; });
    opener = trigger;
    lb.hidden = false;
    document.documentElement.classList.add('dl-lb-open');
    show(start);
    closeBtn.focus();
    return true;
  }

  function close() {
    if (!lb || lb.hidden) return;
    lb.hidden = true;
    document.documentElement.classList.remove('dl-lb-open');
    if (opener && opener.focus) opener.focus({ preventScroll: true });
  }

  /* ---------- 2. Mobile arrows + counter on the main image ---------- */
  var mobile = window.matchMedia('(max-width: 749px)');

  function viewerParts(el) {
    var viewer = el.closest('[id^="GalleryViewer"]');
    if (!viewer) return null;
    var list = viewer.querySelector('.product__media-list');
    var items = list ? Array.prototype.filter.call(list.children, function (li) { return li.offsetWidth > 0; }) : [];
    return { viewer: viewer, list: list, items: items };
  }

  function currentSlide(parts) {
    var w = parts.items[0] ? parts.items[0].offsetWidth : 1;
    return Math.min(parts.items.length - 1, Math.max(0, Math.round(parts.list.scrollLeft / w)));
  }

  function updateCounter(parts) {
    var n = currentSlide(parts);
    var current = parts.viewer.querySelector('.slider-counter--current');
    var total = parts.viewer.querySelector('.slider-counter--total');
    if (current) current.textContent = n + 1;
    if (total) total.textContent = parts.items.length;
    var prev = parts.viewer.querySelector('.slider-button--prev');
    var next = parts.viewer.querySelector('.slider-button--next');
    if (prev) prev.toggleAttribute('disabled', n === 0);
    if (next) next.toggleAttribute('disabled', n >= parts.items.length - 1);
  }

  document.querySelectorAll('[id^="GalleryViewer"] .product__media-list').forEach(function (list) {
    var timer;
    list.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { var p = viewerParts(list); if (p && mobile.matches) updateCounter(p); }, 60);
    }, { passive: true });
    var p = viewerParts(list);
    if (p && mobile.matches) updateCounter(p);
  });

  /* ---------- 3. Description images: load on open, at a sensible width ---------- */
  function loadDescriptionImages(root) {
    root.querySelectorAll('img[data-dl-src]').forEach(function (pic) {
      var src = pic.getAttribute('data-dl-src');
      if (/cdn\.shopify\.com|\/cdn\/shop\//.test(src) && !/[?&]width=/.test(src)) {
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=960';
      }
      pic.src = src;
      pic.removeAttribute('data-dl-src');
    });
  }
  document.querySelectorAll('.dl-pdp-acc details').forEach(function (d) {
    if (d.open) loadDescriptionImages(d);
    d.addEventListener('toggle', function () { if (d.open) loadDescriptionImages(d); });
  });

  // Capture phase: handle the image's own arrows on mobile, and open the preview on image click.
  document.addEventListener('click', function (e) {
    var arrow = e.target.closest && e.target.closest('[id^="GalleryViewer"] .slider-button');
    if (arrow && mobile.matches) {
      var parts = viewerParts(arrow);
      if (!parts || !parts.items.length) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var step = arrow.classList.contains('slider-button--next') ? 1 : -1;
      var target = Math.min(parts.items.length - 1, Math.max(0, currentSlide(parts) + step));
      parts.list.scrollTo({ left: parts.items[target].offsetLeft - parts.items[0].offsetLeft, behavior: 'smooth' });
      return;
    }

    var toggle = e.target.closest && e.target.closest('.product__media-toggle');
    if (!toggle || toggle.closest('quick-add-modal')) return;
    var item = toggle.closest('.product__media-item');
    var gallery = toggle.closest('media-gallery');
    if (!item || !gallery || item.querySelector('video, model-viewer, iframe, deferred-media')) return;
    if (open(gallery, item.getAttribute('data-media-id'), toggle)) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
})();
